import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { Action } from "shared/types/Action"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { FilteredRoomMultiActionHandlers } from "./useRoomMultiActionHandlers"

export interface UseRoomMultiActionsArgs
  extends Partial<FilteredRoomMultiActionHandlers> {
  isDeleteDisabled?: boolean
}

export function useRoomMultiActions({
  onDelete,
  isDeleteDisabled
}: UseRoomMultiActionsArgs) {
  const { t } = useTranslation()

  const deleteAction: Action = useMemo(
    () => ({
      id: "room__multi-actions__delete",
      icon: IconName.BIN,
      label: t("Room.Actions.Delete"),
      isDanger: true,
      disabled: isDeleteDisabled,
      onClick: onDelete ?? undefined
    }),
    [isDeleteDisabled, onDelete]
  )

  const actions: Action[] = useMemo(
    () => [deleteAction].filter(action => !!action.onClick),
    [deleteAction]
  )

  return {
    actions,
    deleteAction
  }
}
